module.exports = __webpack_public_path__ + "img/ordHialuronic3.cc1cf7c5.jpg";